import {
  Button,
  FormControlLabel,
  Grid,
  Switch,
  Typography,
  makeStyles,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { lang } from "i18nLang";
import { observer } from "mobx-react";
import { SendToBillingStore as Store } from "store";
import ResourcesByCityRow from "./ResourcesByCityRow";

const useStyles = makeStyles((theme) => ({
  container: {
    height: "calc(100% - 52px)",
    overflow: "hidden auto",
    paddingBottom: "1rem",
  },
  title: {
    fontSize: "0.75rem",
    fontWeight: 500,
    color: theme.palette.gray?.[900],
  },
  grayText: {
    color: theme.palette.gray?.[600],
  },
}));

/** Tabela de 'Recursos por Município' para enviar a medição para Faturamento. */
const ResourcesByCity = observer(() => {
  const classes = useStyles();
  const rows = Store.citiesItems;
  const measurement = Store.selectedMeasurement;
  const separateReadjust = Store.separateReadjust;

  const handleClickAddCity = () => {
    Store.addCitiesItem();
  };

  const handleChangeSeparateReadjust = (event) => {
    const newValue = event.target.checked;
    Store.setSeparateReadjust(newValue);
  };

  return (
    <Grid container className={classes.container}>
      <Grid container direction="column" justifyContent="flex-start">
        <Grid container className="mb-2">
          <Grid
            container
            item
            className="mb-2"
            alignItems="flex-end"
            spacing={4}
          >
            <Grid item xs={12} md={4}>
              <Typography className={classes.title}>
                {measurement?.description || ""}
              </Typography>
            </Grid>
            <Grid container item xs={12} md={4}>
              <Typography className={classes.title}>
                {lang("billing.measurementAndReadjustment")}
              </Typography>
            </Grid>
            {separateReadjust && (
              <Grid
                container
                item
                xs={12}
                md={3}
                direction="row"
                justifyContent="space-evenly"
                alignItems="center"
              >
                <Grid item xs={6}>
                  <Typography className={classes.title}>
                    {lang("measurement")}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography className={classes.title}>
                    {lang("readjustiment")}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Grid>
          {rows.map((row, index) => (
            <ResourcesByCityRow
              key={row.id}
              index={index}
              rowData={row}
              apportiongTotal={Store.citiesItemsApportioningTotal}
              separateReadjust={separateReadjust}
            />
          ))}
        </Grid>
        <Grid container item justifyContent="center" className="mb-2">
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClickAddCity}
          >
            <AddIcon className="mr-1" /> {lang("billing.newCounty")}
          </Button>
        </Grid>
        <Grid container item justifyContent="center">
          <FormControlLabel
            className={classes.grayText}
            control={
              <Switch
                checked={separateReadjust}
                onChange={handleChangeSeparateReadjust}
                size="small"
                color="primary"
              />
            }
            label={lang("billing.separateReadjustment")}
          />
        </Grid>
      </Grid>
    </Grid>
  );
});

export default ResourcesByCity;
